import { Typography, Box, Tooltip, IconButton } from "@mui/material";
import { colors } from "../theme";
import InfoIcon from "@mui/icons-material/Info";

const MediumTypog = ({ title, desc, mrb='30px'}) => {
  return (
    <Box mb={mrb}>
      <Box display="flex" alignItems="center">
        <Typography
          fontSize='1.3rem'
          color={colors.grey[100]}
          fontWeight='600'
          sx={{ m: "5px 7px 5px 0" }}
        >
          {title}
        </Typography>
        {desc ?(
        <Tooltip
          title={
            <Typography variant="body2" sx={{ fontSize: 13, padding: '0.5rem' }}>
              {desc}
            </Typography>
          }
          sx={{ justifyContent: "left"}}
        >
          <IconButton
            sx={{
              
              backgroundColor: "#3a3a3a",
              "&:hover": { backgroundColor: "#4a4a4a" },
              
            }}
          >
            <InfoIcon sx={{fontSize: 12,}} />
          </IconButton>
        </Tooltip>) : (null)}
      </Box>
    </Box>
  );
};

export default MediumTypog;
